import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { BubbleAlert, ModalBg } from '@styles/base.style'
import BetCompleteCharacter from '@assets/images/bg/character/bet-complete-character.png'
import { MAX_BET_ALERT_TEXT2, MESSAGE_ALERT_TEXT1, MESSAGE_ALERT_TEXT2, SUCCESS_PRE_BET_TEXT3, SUCCESS_PRE_BET_TEXT2 } from '@constants/index'
import useRootStore from '@store/useRootStore'
import { BubbleTextType, BubbleType } from '@store/globalStore'
import { Button } from '@styles/button.style'
import BetCompleteCharacter2 from '@assets/images/bg/character/message-alert-character2.png'
import { isMobile } from 'react-device-detect'

interface BubblePopupProps {
  type: BubbleType
}


const BubblePopup: React.FC<BubblePopupProps> = (props: BubblePopupProps) => {
  const { globalStore } = useRootStore()
  const { type } = props
  const { bubbleData } = globalStore

  const onClickCloseBubble = () => {
    globalStore.initBubble()
  }

  const makeSuccessBubble = () => {
    return (
      <BubbleAlert className="bet-complete-alert">
        {/* 투명 레이어 */}
        <ModalBg className="none" onClick={onClickCloseBubble}/>
        <Button className="bubble-contents" onClick={onClickCloseBubble}>
          <img src={BetCompleteCharacter} alt="베팅 완료 안내 캐릭터"/>
          <span className="complete-txt">
                    베팅이 완료됐습니다.
                    <span className="sub-txt">
                      {bubbleData[type].text}
                      <span className="point-color--red">{SUCCESS_PRE_BET_TEXT2}</span>
                      {SUCCESS_PRE_BET_TEXT3}
                    </span>
                  </span>
        </Button>
      </BubbleAlert>
    )
  }

  const makeLiveSuccessBubble = () => {
    return (
      <BubbleAlert className="bet-complete-alert">
        {/* 투명 레이어 */}
        <ModalBg className="none" onClick={onClickCloseBubble}/>
        <Button className="bubble-contents" onClick={onClickCloseBubble}>
          <img src={BetCompleteCharacter} alt="베팅 완료 안내 캐릭터"/>
          <span className="complete-txt">
                    베팅이 완료됐습니다.
                    <span className="sub-txt">
                      {bubbleData[type].text}
                    </span>
                  </span>
        </Button>
      </BubbleAlert>
    )
  }

  const makeAlertOtherBubble = () => {
    return (
      <BubbleAlert className="bet-alert">
        {/* 투명 레이어 */}
        <ModalBg className="none" onClick={onClickCloseBubble}/>
        <Button className="bubble-contents" onClick={onClickCloseBubble}>
          {bubbleData[type].text}
        </Button>
      </BubbleAlert>
    )
  }

  const makeAlertMaxBetBubble = () => {
    return (
      <BubbleAlert className={isMobile ? 'bet-alert no-tail max-bet' : 'bet-alert no-tail max-bet pc'}>
        {/* 투명 레이어 */}
        <ModalBg className="none" onClick={onClickCloseBubble}/>
        <Button className="bubble-contents" onClick={onClickCloseBubble}>
          {bubbleData[type].text}
          <br/>
          <span className="point-color--yellow">
            {MAX_BET_ALERT_TEXT2}
          </span>
        </Button>
      </BubbleAlert>
    )
  }

  const makeAlertMessageBubble = () => {
    return (
      <BubbleAlert className="message-alert">
        {/* 투명 레이어 */}
        <ModalBg className="none" onClick={onClickCloseBubble}/>
        <Button className="bubble-contents" onClick={onClickCloseBubble}>
          <img src={BetCompleteCharacter2} alt="메시지 안내 캐릭터" style={{ width: 52, marginRight: 6 }}/>
          <span className="info-txt">
            {MESSAGE_ALERT_TEXT1}
            <br/>
            {MESSAGE_ALERT_TEXT2}
          </span>
        </Button>
      </BubbleAlert>
    )
  }

  const makeBubble = () => {
    switch (bubbleData[type].type) {
      case BubbleTextType.SUCCESS:
        return makeSuccessBubble()
      case BubbleTextType.LIVE_SUCCESS:
        return makeLiveSuccessBubble()
      case BubbleTextType.DEFAULT_ALERT:
        return makeAlertOtherBubble()
      case BubbleTextType.MAX_BET_ALERT:
        return makeAlertMaxBetBubble()
      case BubbleTextType.MESSAGE_ALERT:
        return makeAlertMessageBubble()
    }

    return ('')
  }

  return (
    <Fragment>
      {bubbleData[type].visible && makeBubble()}
    </Fragment>
  )
}

export default observer(BubblePopup)
